<div class="commonWrapper">
  <div class="svgWrapper" #svgContainer></div>
  <app-d3-chart-checkboxes
    [arrayTwoInColumn]="arrayTwoInColumn"
    [hideCommonValues]="hideCommonValues"
    [checkboxOptions]="checkboxOptions"
    (switchCheckbox)="onMeasurementCheckboxClicked($event)" />
</div>
